import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import MODULE_ICONS from "../../data/moduleIcons";
import { ArrowDownIcon } from "../Icons";
import { LogIEIconSmall } from "../Icons/Header-Icons";
import { StyledModuleIcon } from "./Modules-styled";

const ModuleIcon = ({
  module,
  showTitle = false,
  title,
  children,
  showArrow = true,
  total,
  isHeader,
  fontColor = "#fff",
  ...props
}) => {
  const { t } = useTranslation("common");
  const icon = useMemo(() => {
    if (module) {
      return MODULE_ICONS[module] ?? MODULE_ICONS.default;
    } else {
      return <LogIEIconSmall width="18" height="18" />;
    }
  }, [module]);

  return (
    <StyledModuleIcon {...props}>
      {!isHeader ? (
        icon
      ) : (
        <svg
          stroke="currentColor"
          strokeWidth="0"
          viewBox="0 0 256 256"
          height="24"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          style={{
            position: "absolute",
            left: 14,
            top: "50%",
            transform: "translateY(-50%)",
          }}
        >
          <path d="M208,88H48a16,16,0,0,0-16,16v96a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V104A16,16,0,0,0,208,88Zm0,112H48V104H208v96ZM48,64a8,8,0,0,1,8-8H200a8,8,0,0,1,0,16H56A8,8,0,0,1,48,64ZM64,32a8,8,0,0,1,8-8H184a8,8,0,0,1,0,16H72A8,8,0,0,1,64,32Z"></path>
        </svg>
      )}
      {showTitle && (
        <span
          className="text-elipsis"
          style={{
            color: fontColor,
            fontWeight: "400",
            fontSize: 17,
            lineHeight: "normal",
          }}
        >
          {title || t("screen.widget.ModuleSwitcher." + module + ".name", "")}
          {showArrow && (
            <>
              {!title && (
                <ArrowDownIcon style={{ marginLeft: 10 }} fill="currentColor" />
              )}
            </>
          )}
          {children}
        </span>
      )}
    </StyledModuleIcon>
  );
};

export default ModuleIcon;
